import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadBrands (options) {
    const params = {
      limit: 500,
      offset: 0,
      is_archived: false,
      ordering: 'name',
      ...options
    }

    return new Promise((resolve, reject) => {
      axiosInstance.get('/brands/', { params }).then((res) => {
        resolve(res.data.results)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async createBrand (brand) {
    return new Promise((resolve, reject) => {
      axiosInstance.post('/brands/', brand).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateBrand (brand) {
    return new Promise((resolve, reject) => {
      delete brand.image
      axiosInstance.patch(`/brands/${brand.id}/`, brand).then((res) => {
        resolve(res.data)
        console.log('res.data:', res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async deleteBrand (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.delete(`/brands/${id}/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
